import { useState, useEffect } from 'react'
import { api, HealthResponse } from '../lib/api'

export function useHealthCheck() {
  const [health, setHealth] = useState<HealthResponse | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let mounted = true

    async function fetchHealth() {
      try {
        setIsLoading(true)
        setError(null)
        const data = await api.health()
        if (mounted) {
          setHealth(data)
        }
      } catch (err) {
        if (mounted) {
          setError(err instanceof Error ? err.message : 'Failed to fetch health')
        }
      } finally {
        if (mounted) {
          setIsLoading(false)
        }
      }
    }

    fetchHealth()

    return () => {
      mounted = false
    }
  }, [])

  return { health, isLoading, error }
}
